import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { i18nService } from "src/app/service-utils/i18n.service";

@Component({
    selector: 'app-home-orders-dialog',
    templateUrl: './home-orders-dialog.component.html',
    styleUrls: ['./home-orders-dialog.component.scss']
  })
  export class HomeOrdersDialogComponent {
  
    constructor(
      public dialogRef: MatDialogRef<HomeOrdersDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      public i18nService: i18nService,
    ) {
    }
  
    okClick(): void {
      this.dialogRef.close();
    }
  
  }